import { render, staticRenderFns } from "./DefaultDepartmentCreateEditModal.vue?vue&type=template&id=6228e545"
import script from "./DefaultDepartmentCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DefaultDepartmentCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports